import React from "react";

const EmployeeCard = ({ emp_photo, emp_name, emp_designation }) => {
    return (
        <div
            className="employee-card"
            style={{
                "--bg-out": `url(/assets/emp_photos/EMP_bg_OUT.png)`,
                "--bg-in": `url(/assets/emp_photos/EMP_bg_IN.png)`
            }}
        >
            <div className="employee-image">
                <img
                    src={`/assets/emp_photos/${emp_photo}`}
                    className="img-fluid"
                    alt={emp_name}
                />
            </div>

            {/* INFO OVERLAY */}
            <div className="employee-info">
                <h3>{emp_name}</h3>
                <p>{emp_designation}</p>
            </div>
        </div>
    );
};

export default EmployeeCard;
